export default {
  handle(err) {
    window.trackJs.track(err)
    console.log(err)
  },
}
